// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__+Vey2","title":"ErrorBoundary_title__swFJF","fence":"ErrorBoundary_fence__KlQ0Q","errorBox":"ErrorBoundary_errorBox__BBYML"};